import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_EM_UTILIZATION_LIST = "GET_EM_UTILIZATION_LIST";

export const service = async (data) => {
  const options: object = {
    url: '/Api/Analytics/GetEmUtilizationDataSourceList',
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_EM_UTILIZATION_LIST, service, mock);
